import App from "./App.svelte";

const openCompareTool = (container, specIds = null, initModel = null) => {
    const app = new App({
        target: container,
        props: {
            specIds,
            initModel,
        },
    });
    app.$on("destroy", () => {
        app.$destroy();
    });
};

const container = document.querySelector("#specs-compare-tool");

const btns = document.querySelectorAll(".open-specs-compare-tool");
btns.forEach((el) =>
    el.addEventListener("click", () =>
        openCompareTool(container, [el.dataset.specId])
    )
);

const btn = document.querySelector("#open-specs-compare-tool");
if (btn) {
    btn.addEventListener("click", () => {
        const { vendor, model, imgSrc } = btn.dataset;
        openCompareTool(container, null, {
            vendorSlug: vendor,
            modelSlug: model,
            imgSrc,
        });
    });
}

const params = window.location.search;
if (params && params.indexOf('compare-specs') > -1) {
    const specs = params.split('=')[1]
    const specIds = specs.split(',')
    openCompareTool(container, specIds);
}

